import React from 'react';
import { useTranslation } from 'react-i18next';
import routes from '../../../router/routes';
import useQueryString from '../../../hooks/useQueryString';
import DictionaryList from '../../../containers/shared/DictionaryList';
import {
  useGetPackageCancellationRequestReasonsQuery
} from '../../../store/apis/dictionaries/package-cancellation-request-reasons';

const List = () => {
  const [t] = useTranslation();
  const { page = 1, pageSize = 20 } = useQueryString();
  const { data, isLoading, isFetching } = useGetPackageCancellationRequestReasonsQuery({ page, pageSize });

  return (
    <DictionaryList
      title={t('Причины отмены пакета')}
      data={data?.results}
      dataCount={data?.count}
      loading={isLoading || isFetching}
      detailRoute={routes.packageCancellationRequestsReasons}
    />
  );
};

export default List;
